'use client'

import { Skeleton } from '@brew/ui/skeleton'
import dynamic from 'next/dynamic'

export type { ScaledEmailHtmlFrameProps } from './scaled-email-html-frame'

// HTML parsing belongs to the HTML lane, not every importing route. Keep
// SSR enabled so exact-import source still paints in the server response.
export const ScaledEmailHtmlFrame = dynamic(
  () =>
    import('./scaled-email-html-frame').then(
      (module) => module.ScaledEmailHtmlFrame
    ),
  { loading: () => <Skeleton className="h-[480px] w-full" /> }
)
